import * as React from "react";
import { Route } from "react-router-dom";
import { routes } from "src/routes";
import {
  KudosNumber,
  Label,
  ProfileEmail,
  ProfileName,
  SingOutButton,
  Wrapper,
  WrapperPosition,
} from "./ProfileStyled";
import { ProfileImage } from "src/theme/objects/Images";
import KudosContext from "src/context";

export class ProfileComponent extends React.Component<{}> {
  public static contextType = KudosContext;
  public context!: React.ContextType<typeof KudosContext>;

  public render() {
    const { image_url, display_name, email, kudos_received, kudos_given } =
      this.context!.profile!;
    return (
      <WrapperPosition>
        <Wrapper>
          <ProfileImage path={image_url} />
          <ProfileName>{display_name}</ProfileName>
          <ProfileEmail>{email}</ProfileEmail>
          <Label>Kudos received</Label>
          <KudosNumber>{kudos_received}</KudosNumber>
          <Label>Kudos given</Label>
          <KudosNumber>{kudos_given}</KudosNumber>
          <Route
            render={(history) => (
              <SingOutButton revers={true} onClick={() => this.logout(history)}>
                Sign out
              </SingOutButton>
            )}
          />
        </Wrapper>
      </WrapperPosition>
    );
  }

  private logout = (history) => {
    localStorage.removeItem("KudosAuthToken");
    this.context!.fetchProfile();
    history.push(routes.login);
  };
}
